import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";

import moment from "moment";

const NomineeDetailsSummary = (props) => {
  const Data = props?.formDataNominee;
  console.log("Data", Data);
  return (
    <div style={{ padding: "9px 0" }}>
      <Row>
        <Col sm={6} lg={4}>
          <div class="form-group">
            <div>
              <label style={{ fontSize: "14px" }}>Full Name</label>
            </div>
            <div style={{ marginTop: "-10px", fontSize: "13px" }}>
              {Data?.NomineeName || "N/A"}
            </div>
          </div>
        </Col>
        <Col sm={6} lg={4}>
          <div class="form-group">
            <div>
              <label style={{ fontSize: "14px" }}>Your Age</label>
            </div>
            <div style={{ marginTop: "-10px", fontSize: "13px" }}>
              {Data?.NomineeAge || "N/A"}
            </div>
          </div>
        </Col>
        <Col sm={6} lg={4}>
          <div class="form-group">
            <div>
              <label style={{ fontSize: "14px" }}>
                Relationship With Proposer
              </label>
            </div>
            <div style={{ marginTop: "-10px", fontSize: "13px" }}>
              {Data?.NomineeRelation || "N/A"}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        {/* Address Section */}
        <Col sm={6} lg={4}>
          <div class="form-group">
            <div>
              <label style={{ fontSize: "14px" }}>
                Is the address is same as proposer?
              </label>
            </div>
            <div style={{ marginTop: "-10px", fontSize: "13px" }}>
              {Data?.IsPropertyAddressSame === "N" ? "NO" : "YES" || "N/A"}
            </div>
          </div>
        </Col>
      </Row>
      {Data?.IsPropertyAddressSame == "N" && (
        <>
          <Row>
            <br />
            {/* Render will be on YES NO Value */}
            <b
              style={{
                marginTop: "7px",
                marginBottom: "10px",
                fontSize: "20px",
                marginLeft: "15px",
              }}
            >
              Address Of Nominee
            </b>
          </Row>
          <Row>
            <Col sm={6} lg={4}>
              <div class="form-group">
                <div>
                  <label style={{ fontSize: "14px" }}>Address line1</label>
                </div>
                <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                  {Data?.RiskCoverAddress1 || "N/A"}
                </div>
              </div>
            </Col>

            <Col sm={6} lg={4}>
              <div class="form-group">
                <div>
                  <label style={{ fontSize: "14px" }}>Address line2</label>
                </div>
                <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                  {Data?.RiskCoverAddress2 || "N/A"}
                </div>
              </div>
            </Col>

            <Col sm={6} lg={4}>
              <div class="form-group">
                <div>
                  <label style={{ fontSize: "14px" }}>Pin-code</label>
                </div>
                <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                  {Data?.RiskCoverPincode || "N/A"}
                </div>
              </div>
            </Col>

            <Col sm={6} lg={4}>
              <div class="form-group">
                <div>
                  <label style={{ fontSize: "14px" }}>State</label>
                </div>
                <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                  {Data?.RiskCoverStateName || "N/A"}
                </div>
              </div>
            </Col>
            <Col sm={6} lg={4}>
              <div class="form-group">
                <div>
                  <label style={{ fontSize: "14px" }}>City</label>
                </div>
                <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                  {Data?.RiskCoverCityName || "N/A"}
                </div>
              </div>
            </Col>
          </Row>
        </>
      )}

      {/* Appointee Details Section */}
      {Data?.NomineeAge < 18 && (
        <>
          <strong>Note:</strong>
          <span>
            {" "}
            Since the above nominee is Minor, please provide the detail of an
            appointee
          </span>
          <br />
          <Row>
            <Col sm={6} lg={4}>
              <div class="form-group">
                <div>
                  <label style={{ fontSize: "14px" }}>Full Name</label>
                </div>
                <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                  {Data?.ApointeeName || "N/A"}
                </div>
              </div>
            </Col>

            <Col sm={6} lg={4}>
              <div class="form-group">
                <div>
                  <label style={{ fontSize: "14px" }}>
                    {" "}
                    Relationship With Nominee
                  </label>
                </div>
                <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                  {Data?.ApointeeRelationToNominee || "N/A"}
                </div>
              </div>
            </Col>
          </Row>
          {Data?.IsApointeeAddressSameAsProposer == "N" && (
            <>
              <b
                style={{
                  marginTop: "7px",
                  marginBottom: "10px",
                  fontSize: "20px",
                }}
              >
                Address Of Appointee
              </b>
              <br />
              <Row>
                <Col sm={6} lg={4}>
                  <div class="form-group">
                    <div>
                      <label style={{ fontSize: "14px" }}>Address line1</label>
                    </div>
                    <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                      {Data?.ApointeeAddress1 || "N/A"}
                    </div>
                  </div>
                </Col>

                <Col sm={6} lg={4}>
                  <div class="form-group">
                    <div>
                      <label style={{ fontSize: "14px" }}>Address line2</label>
                    </div>
                    <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                      {Data?.ApointeeAddress2 || "N/A"}
                    </div>
                  </div>
                </Col>

                <Col sm={6} lg={4}>
                  <div class="form-group">
                    <div>
                      <label style={{ fontSize: "14px" }}>Pin-code</label>
                    </div>
                    <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                      {Data?.ApointeePincode || "N/A"}
                    </div>
                  </div>
                </Col>

                <Col sm={6} lg={4}>
                  <div class="form-group">
                    <div>
                      <label style={{ fontSize: "14px" }}>State</label>
                    </div>
                    <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                      {Data?.ApointeeStateName || "N/A"}
                    </div>
                  </div>
                </Col>
                <Col sm={6} lg={4}>
                  <div class="form-group">
                    <div>
                      <label style={{ fontSize: "14px" }}>City</label>
                    </div>
                    <div style={{ marginTop: "-10px", fontSize: "13px" }}>
                      {Data?.ApointeeCityName || "N/A"}
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default NomineeDetailsSummary;
